var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$vuetify.breakpoint.mobile)?_c('ChatDesktop'):_c('ChatMobile')}
var staticRenderFns = []

export { render, staticRenderFns }